/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo, useCallback } from 'react';
import { TableProps } from 'antd';
import { ViewResolver } from '@Components/ViewResolver';
import {
  ApprovalsTasksRequisitionResponse,
  ApprovalsTasksResponse,
} from '@Types/api/approvalsList';
import RequestList, { RequestListProps } from './desktop/RequestListDesktop';
import RequestListMobile, {
  RequestListMobileProps,
} from './mobile/RequestListMobile';
import { TableTaskListActions } from './tableActions';

interface ApprovalsRequestListProps
  extends Omit<RequestListProps, 'renderActionColumn'>,
    RequestListMobileProps {
  rowSelection: TableProps['rowSelection'];
  selectedTasksRow:
    | ApprovalsTasksResponse[]
    | ApprovalsTasksRequisitionResponse[];
  title: TableProps['title'];
  onBulkApprove?: () => void;
  onBulkReject?: () => void;
  onApproveReject?: () => void;
  onApprovalHistory?: (requestNo: string, isIt?: boolean) => void;
}

const ApprovalsRequestList: React.FC<ApprovalsRequestListProps> = (
  props
): JSX.Element => {
  const {
    onApproveReject,
    onApprovalHistory,
    onBulkApprove,
    onBulkReject,
    onLoadMore,
    listRequests,
    requestsDataList,
    requestType,
    rowSelection,
    selectedTasksRow,
    ...restProps
  } = props;

  const renderActionColumn = useCallback(
    (_text: any, record: any) => {
      return (
        <TableTaskListActions
          record={record}
          onApproveReject={onApproveReject}
          onApprovalHistory={onApprovalHistory}
        />
      );
    },
    [onApprovalHistory, onApproveReject]
  );

  return (
    <ViewResolver
      desktop={
        <RequestList
          {...restProps}
          rowSelection={rowSelection}
          context="approvals"
          renderActionColumn={renderActionColumn}
        />
      }
      mobile={
        <RequestListMobile
          onLoadMore={onLoadMore}
          onApprovalHistory={onApprovalHistory}
          onApproveReject={onApproveReject}
          listRequests={listRequests}
          requestsDataList={requestsDataList}
          context="approvals"
          requestType={requestType}
          onSelectTask={rowSelection?.onChange}
          onBulkApprove={onBulkApprove}
          onBulkReject={onBulkReject}
          selectedTasksRow={selectedTasksRow}
        />
      }
    />
  );
};

export default memo(ApprovalsRequestList) as typeof ApprovalsRequestList;
